


















































import { IJob, IPaginatedData, jobHelper, supplyHelper } from '@homeserve/vue-api-plugin';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const jobNS = namespace('api/order/job');
const supplyNS = namespace('api/trader/supplyManager');

@Component({
  components: {
    SummaryCard: () => import('../components/cards/SummaryCard.vue'),
    InfiniteLoading: () => import('vue-infinite-loading'),
  },
})
export default class List extends Vue {
  @jobNS.Getter('jobs')
  private jobs!: IPaginatedData<IJob>;

  @supplyNS.Getter('paginatedSupplyManagers')
  private paginatedSupplyManagers!: IPaginatedData<any>;

  @supplyNS.Getter('errorFetchingSupplyManagers')
  private errorFetchingSupplyManagers!: boolean;

  @Prop({ default: false })
  private showFilters!: boolean;

  private items: IJob[] = [];
  private page = 1;
  private error = null;
  private identifier = 1;
  private fab = false;
  private exceptStatus = ['new'];
  private isSupplyLoading = false;

  get filter() {
    return this.$store.getters.listFilter;
  }

  get supplyManagers() {
    return this.paginatedSupplyManagers.data;
  }

  private async created() {
    this.isSupplyLoading = true;
    await supplyHelper.fetchSupplyManagers(this.$store, undefined);
    this.isSupplyLoading = false;
  }

  private setFilter() {
    this.$store.commit('SET_LIST_FILTER', this.filter);
    this.refresh();
  }

  private async fetchJobs(page: number = 1, params?: object) {
    try {
      await jobHelper.fetchJobs(this.$store, {
        sortOrder: 'DESC',
        page: page || this.page,
        ...params,
      });
    } catch (error) {
      this.error = error;
    }
  }

  private async infiniteHandler($state: any) {
    await this.fetchJobs(this.page, {
      exceptStatus: this.filter.withoutExceptStatus ? [] : this.exceptStatus,
      supplyManager: this.filter.supplyManager,
    });
    this.page += 1;
    if (this.jobs.data && this.jobs.data.length && this.jobs.data.length > 0) {
      this.items.push(...this.jobs.data);
      $state.loaded();
    } else {
      $state.complete();
    }
  }

  private onScroll() {
    if (typeof window === 'undefined') {
      return;
    }
    const top = window.pageYOffset || document.documentElement.offsetTop || 0;
    this.fab = top > 300;
  }
  private toTop() {
    this.$router.push({ hash: '' });
    this.$vuetify.goTo(0);
  }

  private async refresh() {
    this.page = 1;
    this.identifier += 1;
    this.items = [];
  }
}
